/**
 * Application configuration
 */
const config = {
  // API settings
  apiUrl: process.env.VITE_API_URL || 'http://localhost:3001/api',
  
  // Base URL for the application (used for generating links in emails)
  baseUrl: process.env.VITE_BASE_URL || 'https://e-signaturetool.netlify.app',
  
  // Debug settings
  debug: true, // Enable debug logging
  
  // Email settings
  emailSender: process.env.VITE_RESEND_SENDER_EMAIL || 'Sign in Seconds <onboarding@resend.dev>',
  
  // Application settings
  appName: 'Sign in Seconds',
  appTagline: 'The e-signature tool for small businesses',
  
  // Storage keys (for local storage)
  storageKeys: {
    documents: 'sign_in_seconds_documents',
    signatures: 'sign_in_seconds_signatures',
    userPreferences: 'sign_in_seconds_preferences',
    userSubscription: 'sign_in_seconds_subscription',
  },
  
  // Document settings
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedFileTypes: ['application/pdf'],
  
  // Supabase settings
  supabaseUrl: process.env.VITE_SUPABASE_URL || 'https://eosftoaflcesswdywjbg.supabase.co',
  supabaseAnonKey: process.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVvc2Z0b2FmbGNlc3N3ZHl3amJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE4MjE2MjMsImV4cCI6MjA1NzM5NzYyM30.zm6ukOoc0uoYA0k6Pvx0QN1hVJRVhkaYBNH200dgC8Y',
  
  // Stripe settings
  stripe: {
    publicKey: process.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
    priceId: process.env.VITE_STRIPE_PRICE_ID || '',
    productName: 'Sign in Seconds Pro',
    productDescription: 'Unlimited document signing and management',
    currency: 'USD',
    amount: 29.00, // Monthly subscription price
  },
  
  // Subscription settings
  subscription: {
    features: [
      'Unlimited document uploads',
      'Unlimited signatures',
      'Email notifications',
      'Document tracking',
      'Secure storage',
      'Cancel anytime'
    ]
  }
};

export default config;
